export default [
  {
    label: 'Male',
    value: 'male',
  },
  {
    label: 'Female',
    value: 'female',
  },
  {
    label: 'Prefer Not To Answer',
    value: 'secret',
  },
];
